import classes from "./categoryTree.module.css"
import { useState } from "react"
import Link from "next/link"
import Image from "next/image"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { useRouter } from "next/navigation"

const HEADER_MENUS_MOBILE = [
  {
    label: "bird feeders",
    subMenu: (
      <div className="flex flex-col">
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/bird-feeders"
        >
          <span>View All Bird Feeders</span>
        </Link>
        <Accordion type="multiple" className="w-full" defaultValue={[]}>
          <AccordionItem value="item-1">
            <AccordionTrigger className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title">
              <h2>Featured Categories</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex w-full flex-col bg-[#F7F7F5]">
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/squirrel-proof-feeders"
                >
                  <span>Squirrels Proof Feeders</span>
                </Link>
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/hummingbird-feeders"
                >
                  <span>Hummingbird Feeders</span>{" "}
                </Link>
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/cardinal-feeders"
                >
                  <span>Cardinal Feeders</span>{" "}
                </Link>
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/bluebird-feeders"
                >
                  <span>Bluebird Feeders</span>{" "}
                </Link>
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/suet-bird-feeders"
                >
                  <span>Suet Feeders</span>{" "}
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-4">
            <AccordionTrigger className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title">
              <h2> Shop by Bird Speices</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="grid grid-cols-3 gap-x-[10px] gap-y-[25px] bg-[#F7F7F5] p-[20px]">
                <Link
                  href="/hummingbird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/bird-speices-1.png"
                  />
                  <p className="mt-[10px] break-words text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Hummingbirds
                  </p>
                </Link>
                <Link
                  href="/bluebird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/bird-speices-2.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Bluebirds
                  </p>
                </Link>
                <Link
                  href="/cardinal-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/bird-speices-3.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Cardinals
                  </p>
                </Link>
                <Link
                  href="/oriole-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/bird-speices-4.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Orioles
                  </p>
                </Link>
                <Link
                  href="/woodpecker-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/bird-speices-5.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Woodpeckers
                  </p>
                </Link>
                <Link
                  href="/blue-jay-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/bird-speices-6.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Blue Jays
                  </p>
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-2">
            <AccordionTrigger className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title">
              <h2>Shop by Feeder Type</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="grid grid-cols-3 gap-x-[10px] gap-y-[25px] bg-[#F7F7F5] p-[20px]">
                <Link
                  href="/platform-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feeder-type-1.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Platform Feeders
                  </p>
                </Link>
                <Link
                  href="/suet-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feeder-type-2.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Suet Feeders
                  </p>
                </Link>
                <Link
                  href="/hopper-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feeder-type-3.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Hopper Feeders
                  </p>
                </Link>
                <Link
                  href="/house-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feeder-type-4.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    House Feeders
                  </p>
                </Link>
                <Link
                  href="/tube-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feeder-type-5.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Tube Feeders
                  </p>
                </Link>
                <Link
                  href="/caged-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feeder-type-6.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Caged Feeders
                  </p>
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-3">
            <AccordionTrigger className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title">
              <h2>Shop by Features</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="grid grid-cols-3 gap-x-[10px] gap-y-[25px] bg-[#F7F7F5] p-[20px]">
                <Link
                  href="/squirrel-proof-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feature-1.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Squirrel Proof Feeders
                  </p>
                </Link>
                <Link
                  href="/weatherproof-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feature-2.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Weatherproof Feeders{" "}
                  </p>
                </Link>
                <Link
                  href="/recycled-plastic-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feature-3.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Recycled Plastic Feeders{" "}
                  </p>
                </Link>
                <Link
                  href="/metal-mesh-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={80}
                    height={80}
                    layout="responsive"
                    src="/images/header-menu/feature-4.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Metal Mesh Feeders{" "}
                  </p>
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-5">
            <AccordionTrigger className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title">
              <h2>Shop by Seed Type</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="grid grid-cols-3 gap-x-[10px] gap-y-[25px] bg-[#F7F7F5] p-[20px]">
                <Link
                  href="/sunflower-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/seed-type-1.png"
                  />
                  <p className="mt-[10px] break-words text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Sunflower
                  </p>
                </Link>
                <Link
                  href="/suet-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/seed-type-2.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Suets
                  </p>
                </Link>
                <Link
                  href="/mixed-seed-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/seed-type-3.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Mixed Seeds
                  </p>
                </Link>
                <Link
                  href="/fruit-nuts-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/seed-type-4.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Fruit & Nuts
                  </p>
                </Link>
                <Link
                  href="/mealworm-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/seed-type-5.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Mealworms
                  </p>
                </Link>
                <Link
                  href="/nyjer-thistle-bird-feeders"
                  className="group flex cursor-pointer flex-col items-center justify-center"
                >
                  <Image
                    className="max-w-[80px]"
                    alt=""
                    width={160}
                    height={160}
                    layout="responsive"
                    src="/images/header-menu/seed-type-6.png"
                  />
                  <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                    Nyjer
                  </p>
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    ),
    hasDropdownMenu: true,
  },
  {
    label: "Smart Feeders",
    href: "/smart-bird-feeder",
    hasDropdownMenu: true,
    subMenu: (
      <div className="flex flex-col gap-[20px] p-[20px]">
        <Link
          href="/smart-green-bird-feeder-1-titto-by-kingsyard-ttbf001cp.html"
          className="group flex w-full cursor-pointer flex-col items-center"
        >
          <Image
            className="w-full"
            alt=""
            width={500}
            height={300}
            layout="responsive"
            href="/titto-smart-bird-feeder-pro-ttbf001cp.html"
          />
          <p className="mt-[10px] font-poppins font-[600] leading-[1.2] text-title group-hover_text-primary group-hover_underline">
            Smart Bird Feeder
          </p>
        </Link>
        <Link
          href="/titto-2-in-1-smart-bird-feeder-ttbf002cp.html"
          className="group flex w-full cursor-pointer flex-col items-center"
        >
          <Image
            className="w-full"
            alt=""
            width={500}
            height={300}
            layout="responsive"
            src="/images/header-menu/smart-bird-versa-feeder.png"
          />
          <p className="mt-[10px] font-poppins font-[600] leading-[1.2] text-title group-hover_text-primary group-hover_underline">
            Smart Bird Versa Feeder
          </p>
        </Link>
      </div>
    ),
  },
  {
    label: "bird houses",
    href: "/bird-houses",
    hasDropdownMenu: true,
    subMenu: (
      <div className="flex flex-col">
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/bird-houses"
        >
          <span>View All Bird Houses</span>
        </Link>
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/bluebird-houses"
        >
          <span> Bluebird Houses</span>
        </Link>
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/chickadee-houses"
        >
          <span>Chikadee Houses</span>{" "}
        </Link>
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/wren-houses"
        >
          <span>Wren Houses</span>{" "}
        </Link>
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/decorative-houses"
        >
          <span>Decorative Houses</span>{" "}
        </Link>
      </div>
    ),
  },
  {
    label: "bird baths",
    href: "/bird-baths",
    hasDropdownMenu: false,
  },
  {
    label: "accessories",
    href: "/accessories",
    hasDropdownMenu: true,
    subMenu: (
      <div className="flex flex-col">
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/accessories"
        >
          <span>View All Accessories</span>
        </Link>

        <Accordion type="multiple" className="w-full" defaultValue={[]}>
          <AccordionItem value="item-2">
            <AccordionTrigger className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title">
              <h2>Birding Accessories</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex w-full flex-col bg-[#F7F7F5]">
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/bird-feeder-accessories"
                >
                  <span>Bird Feeder Accessories</span>
                </Link>
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/poles-hanger-hooks"
                >
                  <span>Poles & Hangers</span>{" "}
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-3">
            <AccordionTrigger className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title">
              <h2>Garden Essentials</h2>
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex w-full flex-col bg-[#F7F7F5]">
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/garden-yard-essentials"
                >
                  <span>Garden & Yard Essentials</span>
                </Link>
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/garden-fencing-privacy-screens"
                >
                  <span>Fencing & Privacy Screens</span>{" "}
                </Link>
                <Link
                  className="flex h-[60px] items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] leading-[60px] text-title"
                  href="/squirrel-feeders"
                >
                  <span>Squirrel Feeders</span>{" "}
                </Link>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    ),
  },
  {
    label: "gifts",
    href: "/gifts",

    hasDropdownMenu: true,
    subMenu: (
      <div className="flex flex-col">
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/gifts"
        >
          <span>View All Gifts</span>
        </Link>
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/top-picked-gifts-for-bird-lovers"
        >
          <span>Top Pick Gifts</span>
        </Link>
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/gifts-under-30"
        >
          <span>Gifts under $30</span>
        </Link>
        <Link
          className="flex h-[60px] cursor-pointer items-center justify-between border-b border-[#ddd] px-[30px] font-poppins font-[600] text-title"
          href="/gifts-under-50"
        >
          <span>Gifts under $50</span>
        </Link>
      </div>
    ),
  },
]

export default function CategoryTree() {
  const [subMenu, setSubMenu] = useState(null)

  const [currentMenu, setCurrentMenu] = useState(null)

  const router = useRouter()

  const onCategoryClick = (temp) => {
    if (temp.hasDropdownMenu) {
      setCurrentMenu(temp.label)
      setSubMenu(temp.subMenu)
    } else {
      router.push(temp.href)
    }
  }

  const onBack = () => {
    setCurrentMenu(null)
    setSubMenu(null)
  }

  return (
    <div>
      {!currentMenu &&
        HEADER_MENUS_MOBILE.map((temp, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                onCategoryClick(temp)
              }}
              className="flex h-[70px] cursor-pointer items-center justify-between border-b border-t border-[#DDDDDD] px-[20px] font-poppins text-[18px] font-[600] capitalize leading-[70px] text-primary"
            >
              <span>{temp.label}</span>
              {temp.hasDropdownMenu ? (
                <span className={classes.icon}></span>
              ) : (
                <span />
              )}
            </div>
          )
        })}
      {currentMenu && (
        <div>
          <div className="relative flex h-[60px] items-center justify-center border-b border-[#ddd] font-poppins text-[18px] font-[600] capitalize text-primary">
            <span className={classes.backIcon} onClick={onBack}></span>
            {currentMenu}
          </div>
          {subMenu}
        </div>
      )}
    </div>
  )
}
